<template>
    <div id="session-timeout-wrap">
  
      <!-- Session Timeout Message -->
      <div class="session-timeout-modal">
        <div class="modal-content">
          <p>You've been logged out due to inactivity.</p>
          <ModalMessage :message="feedbackMessage" :type="feedbackType" />
        </div>
        <div class="button-group">
          <input type="button" @click="goToLogin" class="fa-btn fa-btn-primary fa-btn-modal" value="Login Again">
        </div>
      </div>
  
    </div>
  </template>
  
  <script setup>
  import { ref } from 'vue';
  import { MessageType } from '@/types/enums.ts';
  import { useUIStore } from '@/store/uiStore';
  import { ModalTypes } from '@/types/enums';
  
  const uiStore = useUIStore();

  const feedbackMessage = ref(''); // Placeholder if there are any dynamic messages to be displayed.
  const feedbackType = ref(MessageType.INFO);
  
  function goToLogin() {
    uiStore.setModalType(ModalTypes.LOGIN);
  }
  
  </script>
  
<style lang="scss" scoped>
@import '~/assets/constants.scss';

  .session-timeout-modal {
  }
  
  .button-group {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  </style>
  